import { _, Backbone, Marionette, Radio } from "../../vendor";
import { Dependencies } from "../utils";
import InboomaBaseView from "../views/InboomaBaseView";
import InboomaAccessBarView from "../views/InboomaAccessBarView";

const InboomaBaseController = Marionette.Object.extend({
  app: Radio.channel("app"),

  options: {
    widgetMode: false,
    el: null,
  },

  collection: null,
  layout: {},

  _templateContext: _.noop,

  /**
   * Called mainly by Router.js: Ensures that all (sub-)views do have
   * their required collections/dependencies available
   *
   * @param {Object} dependencies e.g. { ... 'orders' : new Orders(), ... }
   */
  loadDependencies(dependencies) {
    const that = this;

    return new Promise((resolve, reject) => {
      if (!_.size(dependencies) || typeof that._collection !== "undefined") {
        resolve();
      } else {
        new Dependencies(dependencies).then(() => {
          if (that._channelName && that._channelName !== "dashboard") {
            that._collection = Radio.channel(that._channelName).request("get:data");

            if (typeof that._collection.proxy !== "undefined") {
              that.collection = that._collection.proxy;
            }
          }

          that.trigger("dependencies:ready");
          resolve();
        });
      }
    });
  },

  /**
   * Avoids multiple renderings of base/parent template
   * when e.g. its child views are being called
   */
  _shouldRenderLayout() {
    return document.querySelector(this._el) === null;
  },

  setLayout(template, templateContext = {}, forceRender = false) {
    if (typeof template === "undefined") {
      if (typeof this._template !== "undefined") {
        template = this._template;
      } else {
        return false;
      }
    }

    if (forceRender || this._shouldRenderLayout()) {
      // Render loose helper view

      new InboomaBaseView({
        el: "#inb-c",
        template,
        templateContext,
      }).render();

      if (typeof this._accessBarMap !== "undefined") {
        this.accessBar = new InboomaAccessBarView(this._accessBarMap());
      }
    }
  },

  _resetOptions(options = null) {
    // Set or reset options
    // Enables rendering views as both, widget and page

    this.layout = {};

    if (options !== null) {
      if (typeof options.widgetMode !== "undefined") {
        this.widgetMode = options.widgetMode;
      }
    } else {
      // Set back to default
      this.widgetMode = false;
    }

    if (this.widgetMode) {
      this.el = options.el;
    } else {
      this.el = this._el;
    }

    if (
      (typeof this.collection !== "undefined" || typeof this._collection !== "undefined") &&
      typeof this.accessBar !== "undefined"
    ) {
      // this.accessBar.render();
      // Collection fetched, re-render accessBar
      this.accessBar.collection = this.collection !== null ? this.collection : this._collection;
    }
  },

  initialize() {
    this._resetOptions(this.options);
  },

  /**
   * @function _updateCollection
   *
   * If controller was already initialized before,
   * pull and merge any collection-updates from API
   *
   * @todo REFACTOR: Save (local) latest timestamp of collection-fetch request,
   *       then attach it as filter when re-fetching that collection data
   *       (i.e. e.g. "...?modified_gte=this.collection._latestModifiedTimestamp)
   */
  _updateCollection() {
    // @todo Skipped as more tests required
    /*    const collection = this._collection;
      
      if (typeof collection !== 'undefined') {

            collection.fetch({
              add : false,
              merge : false,
              remove : false
            }).then((data) => {
                // Merge response into collection
                // Similiar to collection._setCollectionData

                console.log('UPDATECOLLECTION', data.response.data);

                collection.preventRender = true;
                collection.set(data.response.data, { add:true, merge:true, remove:false })
                collection.preventRender = false;

                collection.trigger('add', collection.models[0], collection);

                console.log('Success resetting collection ' + this._channelName);
                
              })
            
          } */
  },

  /**
   * Check if any canvas is in queue, then open it.
   * Required for OrdersController & ReservationsListController
   * Notice that this._canvasToOpen may be set via OffCanvasOrdersForm
   */
  _processOpenCanvasQueue() {
    if (this._canvasToOpen.destination !== null) {
      Backbone.history.navigate(this._channelName + "/" + this._canvasToOpen.destination, {
        trigger: true,
      });
      this._canvasToOpen.destination = null;
    } else if (this._canvasToOpen.source !== null) {
      this._canvasToOpen.destination = this._canvasToOpen.source;
      this._canvasToOpen.source = null;
    }
  },
});

InboomaBaseController.prototype.t = InboomaBaseView.prototype.t;

export default InboomaBaseController;
